import { toastActions } from 'APP/Store/Toast'
import { ShowToastPayload } from 'APP/Store/Toast/types'

/**
 * Show a global toast notification
 * // Success toast (default)
 * showToast({
 *   title: 'Email invitation sent',
 *   description: 'They can manage care once signed up.',
 *   link: {
 *     url: 'family',
 *     text: 'See Invite',
 *     isExternal: false
 *   },
 *   variant: 'success', // 'success' | 'primary' | 'error'
 *   delay: 5000 // Optional, defaults to 5000ms
 *   hideMenuWebMargin: false // Optional
 * })
 * })
 */

export const showToast = (payload: ShowToastPayload) => {
  const store = require('APP/Store').default
  store.dispatch(toastActions.showToast(payload))
}

// Clear all active toasts
export const clearAllToasts = () => {
  const store = require('APP/Store').default
  store.dispatch(toastActions.clearAllToasts())
}
